import { render, staticRenderFns } from "./GroupListForm.vue?vue&type=template&id=76ce6997"
import script from "./GroupListForm.vue?vue&type=script&lang=js"
export * from "./GroupListForm.vue?vue&type=script&lang=js"
import style0 from "./GroupListForm.vue?vue&type=style&index=0&id=76ce6997&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports